module.exports = __webpack_public_path__ + "img/ad.a079ecd0.png";